const CURRENCIES = [
  { value: "PHP", label: "Philippine Peso" },
  { value: "USD", label: "United States Dollar" },
  { value: "EUR", label: "Euro" },
  { value: "GBP", label: "British Pound" },
  { value: "JPY", label: "Japanese Yen" },
  { value: "KRW", label: "South Korean Won" },
  { value: "CNY", label: "Chinese Yuan" },
  { value: "INR", label: "Indian Rupee" },
  { value: "BRL", label: "Brazilian Real" },
  { value: "MXN", label: "Mexican Peso" },
  { value: "ARS", label: "Argentine Peso" },
];

export const defaultSettings = {
  applicationName: "SLSP",
  currency: "PHP",
};

const systemSettingsSchema = {
  sections: {
    General: {
      label: "General",
      icon: "bi bi-gear",
      description: "Manage system settings",
    },
    "Session & security": {
      label: "Session & security",
      icon: "bi bi-shield-lock",
      description: "Session timeout, login attempts and security options",
    },
  },
  fields: {
    applicationName: {
      type: "String",
      label: "Application name",
      placeholder: "e.g. SLSP",
      section: "General",
      col: "col-12 col-md-6",
    },
    currency: {
      type: "InputSelect",
      label: "Currency",
      placeholder: "Select currency",
      options: CURRENCIES,
      default: CURRENCIES[0],
      section: "General",
      col: "col-12 col-md-6",
    },
  },
};

export default systemSettingsSchema;
